// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.text-area-modal[data-v-bf7c9282]{\r\n\t-ms-flex-item-align: center;\r\n\t    align-self: center;\r\n\t-webkit-box-flex: 1;\r\n\t    -ms-flex-positive: 1;\r\n\t        flex-grow: 1;\r\n\t-ms-flex-negative: 1;\r\n\t    flex-shrink: 1;\r\n\tmax-height: 100vh;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
